export const waitForNonZeroSize = (element: HTMLElement): Promise<void> =>
  new Promise((resolve) => {
    const { width, height } = element.getBoundingClientRect();
    if (width > 0 && height > 0) {
      resolve();
      return;
    }
    let observerTimeout: ReturnType<typeof setTimeout> | number = 0;
    const observer = new ResizeObserver(() => {
      const { width, height } = element.getBoundingClientRect();
      if (width > 0 && height > 0) {
        clearTimeout(observerTimeout);
        observer.disconnect();
        resolve();
      }
    });
    // 10 second timeout avoids waiting indefinitely
    observerTimeout = setTimeout(() => {
      observer.disconnect();
      resolve();
    }, 10000);
    observer.observe(element);
  });

export default waitForNonZeroSize;
